import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    AlertDialogPortal,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useState } from "react";
import TCSEditForm from "./TCSEditForm";
import TCSWarning from "./TCSEditWarning";
import { FormProvider, useForm } from "react-hook-form";
import { TCSFormData } from "pages/GenericOrderDetailsPage/types";
import { useTCSEdit } from "pages/GenericOrderDetailsPage/hooks/useTCSEdit";
import { Spinner } from "components";
import { SquarePen } from "lucide-react";
export default function TCSEditDialog({ tcs, id, displayName }: {
    tcs: number | string;
    id: string;
    displayName: string;
}) {
    const [isTCSEditing, setIsTCSEditing] = useState(false);
    const methods = useForm<TCSFormData>({
        mode: 'onChange'
    });
    const {updateTCS, loading} = useTCSEdit()
    const handleTCSCancel = () => {
        setIsTCSEditing(false);
        methods.reset();
    }
    const tcsValue = methods.watch('tcsValue');
    const isChecked = methods.watch('isChecked');

    const handleTCSSave = async (data: TCSFormData) => {
        updateTCS({
            tcs_amount:Number(data.tcsValue),
            order_id: id
        });
        setIsTCSEditing(false);
        methods.reset();
    }    
    return (
        <AlertDialog open={isTCSEditing} onOpenChange={setIsTCSEditing}>
            <AlertDialogTrigger asChild>
                <button
                    className=""
                    onClick={() => setIsTCSEditing(true)}
                >
                   <SquarePen className="w-4 h-4 text-blue-700" />

                </button>
            </AlertDialogTrigger>
            <AlertDialogPortal>
                {
                    loading && <Spinner />
                }
                <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow">
                    <form className="max-w-md">
                    
                        <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
                            <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-black-label">
                                Edit TCS charges
                            </AlertDialogTitle>
                            <div className="border-b-2 border-gray-300 my-2 w-full"></div>
                            <FormProvider {...methods}>
                                <TCSEditForm
                                    displayName={displayName}
                                    currentTCS={tcs as number}
                                />
                            </FormProvider>
                        </AlertDialogHeader>
                        <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                            <AlertDialogCancel
                                className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                asChild
                            >
                                <button onClick={handleTCSCancel}>Close</button>
                            </AlertDialogCancel>
                            {(tcs as number || 0) > parseInt(tcsValue) ? (
                                <TCSWarning
                                    tcs_amount={tcs as number}
                                    order_id={id}
                                    tcsValue={tcsValue}
                                    handleSubmit={() => {
                                        methods.handleSubmit((data) => {
                                            handleTCSSave(data)
                                        })()
                                    }}
                                >
                                    <AlertDialogAction
                                        className={`rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 ${!isChecked ? "opacity-50 cursor-not-allowed" : ""
                                            }`}
                                    >
                                        Save
                                    </AlertDialogAction>
                                </TCSWarning>
                            ) : (
                                <AlertDialogAction
                                    type="submit"
                                    onClick={methods.handleSubmit((data) => {
                                        handleTCSSave(data)
                                    })}
                                    className={`rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 ${!isChecked ? "opacity-50 cursor-not-allowed" : ""
                                        }`}
                                    disabled={!isChecked || !tcsValue}
                                >
                                    Save
                                </AlertDialogAction>
                            )}
                        </AlertDialogFooter>
                    </form>
                </AlertDialogContent>
            </AlertDialogPortal>
        </AlertDialog>
    )
}